import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useMemo } from 'react';
import Radio from './Radio.js';
import { RadioGroupContext } from './RadioGroupContext.js';
import { GroupWrapper, Group, ErrorMessage } from './styles.js';

const RadioGroup = (_a) => {
    var { name, onChange, selectedRadio, readOnly, inline, errorMessage, error, children } = _a, props = __rest(_a, ["name", "onChange", "selectedRadio", "readOnly", "inline", "errorMessage", "error", "children"]);
    const value = useMemo(() => ({
        name,
        onChange,
        selectedRadio,
        readOnly,
        error,
    }), [name, onChange, selectedRadio, readOnly, error]);
    return (React.createElement(GroupWrapper, Object.assign({}, props),
        React.createElement(RadioGroupContext.Provider, { value: value },
            React.createElement(Group, { inline: inline, role: "radiogroup" }, children),
            errorMessage && (React.createElement(ErrorMessage, { type: "default" }, errorMessage)))));
};
RadioGroup.Radio = Radio;

export { RadioGroup as default };
